require('./_typed-array')('Uint8', 1, function (init) {
  return function Uint8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});



/*****************
 ** WEBPACK FOOTER
 ** ../~/core-js/modules/es6.typed.uint8-array.js
 ** module id = 2411
 ** module chunks = 3
 **/